import { gql } from "@apollo/client";

// Defaults to ACTIVE campaigns on the BFF; any result means "mapped to a live campaign".
export const listCampaignsByStoreGroups = gql`
  query ListCampaignsByStoreGroups($storeGroups: [String!]!) {
    listCampaignsByStoreGroups(storeGroups: $storeGroups) {
      id
      title
    }
  }
`;
